import React from 'react';

const About = () => {
  return (
    <div className="font-sans bg-ink text-white">
      {/* Hero Section */}
      <section className="panel-surface text-white section-padding font-display">
        <div className="container-custom text-center">
          <h1 className="text-5xl font-display font-bold mb-6">
            About IBT Sports
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto font-sans">
            Your trusted partner for licensed sports streaming across America and Europe. 
            We're revolutionizing how fans experience their favorite sports.
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-display font-bold text-white mb-8">
                Our Mission
              </h2>
              <div className="space-y-6">
                <p className="text-lg text-gray-300 leading-relaxed font-sans">
                  At IBT Sports, our mission is to provide sports fans with unparalleled access 
                  to their favorite teams and leagues through cutting-edge streaming technology 
                  and official licensing partnerships.
                </p>
                <p className="text-lg text-gray-300 leading-relaxed font-sans">
                  We believe that every fan deserves to experience the excitement of live sports 
                  in the highest quality possible, regardless of their location or device preference.
                </p>
                <div className="panel-surface p-6 rounded-lg">
                  <h3 className="text-xl font-semibold text-white mb-3 font-display">Our Core Values</h3>
                  <ul className="space-y-2 text-gray-300 font-sans">
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      Every stream is backed by official licensing, compliance, and broadcast-grade security.
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      4K HDR, multi-angle views, and ultra-low latency to deliver the highest quality on every screen.
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      Technology that adapts to fans’ needs, from real-time stats to interactive multi-view.
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      Serving fans in every corner of the world, while honoring local cultures and communities.
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      Pioneering advancements in AI, cloud delivery, and immersive fan engagement.
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      Building long-term value with leagues, teams, advertisers, and global media partners.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <div className="bg-gradient-to-br from-primary to-accent-warm rounded-2xl p-8 text-white font-display shadow-glow-primary">
                <h3 className="text-2xl font-bold mb-4">Our Vision</h3>
                <p className="text-lg mb-6 font-sans">
                To redefine the future of sports entertainment by becoming the world’s most trusted and innovative platform for licensed sports streaming. We aspire to unite billions of fans worldwide through unmatched access, cutting-edge technology, and the highest broadcast standards in the industry.
                </p>
                <div className="grid grid-cols-2 gap-4 text-center">
                  <div className="bg-white bg-opacity-20 rounded-lg p-4">
                    <div className="text-2xl font-bold">3</div>
                    <div className="text-sm">Sports</div>
                  </div>
                  <div className="bg-white bg-opacity-20 rounded-lg p-4">
                    <div className="text-2xl font-bold">50+</div>
                    <div className="text-sm">Countries</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Coverage Areas */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-display font-bold text-white mb-4">
              Global Coverage Areas
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto font-sans">
              We proudly serve sports fans across multiple continents with localized 
              content and regional support.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Americas */}
            <div className="card-glass card-hover group relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-accent-warm/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              {/* Header */}
              <div className="p-8 border-b border-line">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-gradient-to-br from-primary to-accent-warm rounded-xl flex items-center justify-center mr-4 shadow-glow-primary">
                      <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-white font-display">Americas</h3>
                      <div className="badge-official text-xs">Premium Coverage</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-3xl font-bold text-primary font-display">50M+</div>
                    <div className="text-xs text-gray-400 uppercase tracking-wider">Fans Reached</div>
                  </div>
                </div>
                
                {/* Authority Badges */}
                <div className="flex flex-wrap gap-2 mt-4">
                  <span className="badge">Ultra HD</span>
                  <span className="badge">Multi-Language</span>
                  <span className="badge">Local Servers</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="grid grid-cols-1 gap-6">
                  {/* United States */}
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <h4 className="font-semibold text-white font-display flex items-center">
                        <svg className="w-4 h-4 text-primary mr-2" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                        </svg>
                        United States
                      </h4>
                      <div className="text-xs text-gray-400">All 50 States</div>
                    </div>
                    <div className="grid grid-cols-2 gap-2 text-sm text-gray-300 font-sans">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-primary rounded-full mr-2"></div>
                        Dedicated servers
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-primary rounded-full mr-2"></div>
                        24/7 support
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-primary rounded-full mr-2"></div>
                        Local partnerships
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-primary rounded-full mr-2"></div>
                        Regional pricing
                      </div>
                    </div>
                  </div>

                  {/* Canada */}
                  <div className="space-y-3 pt-4 border-t border-line">
                    <div className="flex items-center justify-between">
                      <h4 className="font-semibold text-white font-display flex items-center">
                        <svg className="w-4 h-4 text-primary mr-2" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                        </svg>
                        Canada
                      </h4>
                      <div className="text-xs text-gray-400">Coast to Coast</div>
                    </div>
                    <div className="grid grid-cols-2 gap-2 text-sm text-gray-300 font-sans">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-primary rounded-full mr-2"></div>
                        Bilingual support
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-primary rounded-full mr-2"></div>
                        Local content
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-primary rounded-full mr-2"></div>
                        Regional pricing
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-primary rounded-full mr-2"></div>
                        Native apps
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Europe */}
            <div className="card-glass card-hover group relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-accent-warm/10 to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              {/* Header */}
              <div className="p-8 border-b border-line">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-gradient-to-br from-accent-warm to-primary rounded-xl flex items-center justify-center mr-4 shadow-glow-primary">
                      <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-white font-display">Europe</h3>
                      <div className="badge-official text-xs">Expanding Coverage</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-3xl font-bold text-accent-warm font-display">25M+</div>
                    <div className="text-xs text-gray-400 uppercase tracking-wider">Fans Reached</div>
                  </div>
                </div>
                
                {/* Authority Badges */}
                <div className="flex flex-wrap gap-2 mt-4">
                  <span className="badge">Multi-Language</span>
                  <span className="badge">Local Content</span>
                  <span className="badge">EU Servers</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="grid grid-cols-1 gap-6">
                  {/* Western Europe */}
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <h4 className="font-semibold text-white font-display flex items-center">
                        <svg className="w-4 h-4 text-accent-warm mr-2" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                        </svg>
                        Western Europe
                      </h4>
                      <div className="text-xs text-gray-400">4 Countries</div>
                    </div>
                    <div className="grid grid-cols-2 gap-2 text-sm text-gray-300 font-sans">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-warm rounded-full mr-2"></div>
                        United Kingdom
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-warm rounded-full mr-2"></div>
                        Germany
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-warm rounded-full mr-2"></div>
                        France
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-warm rounded-full mr-2"></div>
                        Netherlands
                      </div>
                    </div>
                  </div>

                  {/* Nordic Region */}
                  <div className="space-y-3 pt-4 border-t border-line">
                    <div className="flex items-center justify-between">
                      <h4 className="font-semibold text-white font-display flex items-center">
                        <svg className="w-4 h-4 text-accent-warm mr-2" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                        </svg>
                        Nordic Region
                      </h4>
                      <div className="text-xs text-gray-400">4 Countries</div>
                    </div>
                    <div className="grid grid-cols-2 gap-2 text-sm text-gray-300 font-sans">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-warm rounded-full mr-2"></div>
                        Sweden
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-warm rounded-full mr-2"></div>
                        Norway
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-warm rounded-full mr-2"></div>
                        Denmark
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-warm rounded-full mr-2"></div>
                        Finland
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Asia Pacific */}
            <div className="card-glass card-hover group relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-accent-success/10 to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              {/* Header */}
              <div className="p-8 border-b border-line">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-gradient-to-br from-accent-success to-primary rounded-xl flex items-center justify-center mr-4 shadow-glow-primary">
                      <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-white font-display">Asia Pacific</h3>
                      <div className="badge-official text-xs">Coming Soon</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-3xl font-bold text-accent-success font-display">15M+</div>
                    <div className="text-xs text-gray-400 uppercase tracking-wider">Target Fans</div>
                  </div>
                </div>
                
                {/* Authority Badges */}
                <div className="flex flex-wrap gap-2 mt-4">
                  <span className="badge">Localization</span>
                  <span className="badge">Regional Content</span>
                  <span className="badge">APAC Servers</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="grid grid-cols-1 gap-6">
                  {/* Australia & NZ */}
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <h4 className="font-semibold text-white font-display flex items-center">
                        <svg className="w-4 h-4 text-accent-success mr-2" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                        </svg>
                        Australia & NZ
                      </h4>
                      <div className="text-xs text-gray-400">Q2 2024</div>
                    </div>
                    <div className="grid grid-cols-2 gap-2 text-sm text-gray-300 font-sans">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-success rounded-full mr-2"></div>
                        Local partnerships
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-success rounded-full mr-2"></div>
                        Regional pricing
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-success rounded-full mr-2"></div>
                        Local servers
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-success rounded-full mr-2"></div>
                        Native apps
                      </div>
                    </div>
                  </div>

                  {/* Southeast Asia */}
                  <div className="space-y-3 pt-4 border-t border-line">
                    <div className="flex items-center justify-between">
                      <h4 className="font-semibold text-white font-display flex items-center">
                        <svg className="w-4 h-4 text-accent-success mr-2" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                        </svg>
                        Southeast Asia
                      </h4>
                      <div className="text-xs text-gray-400">Q3 2024</div>
                    </div>
                    <div className="grid grid-cols-2 gap-2 text-sm text-gray-300 font-sans">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-success rounded-full mr-2"></div>
                        Multi-language
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-success rounded-full mr-2"></div>
                        Local content
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-success rounded-full mr-2"></div>
                        Regional pricing
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-accent-success rounded-full mr-2"></div>
                        Mobile-first
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <div className="card-glass rounded-xl p-8 max-w-3xl mx-auto">
              <h3 className="text-xl font-semibold text-white mb-4 font-display">
                Expanding to New Markets
              </h3>
              <p className="text-gray-300 mb-6 font-sans">
                We're constantly working to bring IBT Sports to new regions. 
                Stay tuned for announcements about upcoming market expansions.
              </p>
              <button className="btn-pill-primary font-display">
                Get Notified About New Markets
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 